"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setAppSessionIdCookie = exports.getAppSessionIdCookie = void 0;

var _nanoid = _interopRequireDefault(require("nanoid"));

var _universalCookie = _interopRequireDefault(require("universal-cookie"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var getAppSessionIdCookie = function getAppSessionIdCookie() {
  var cookies = new _universalCookie["default"]();
  return cookies.get("ftvOption%3AappSessionId") || setAppSessionIdCookie();
};

exports.getAppSessionIdCookie = getAppSessionIdCookie;

var setAppSessionIdCookie = function setAppSessionIdCookie() {
  var cookies = new _universalCookie["default"]();
  var appSessionId = (0, _nanoid["default"])(18);
  cookies.set("ftvOption%3AappSessionId", appSessionId, {
    path: "/"
  });
  return appSessionId;
};

exports.setAppSessionIdCookie = setAppSessionIdCookie;